import React from 'react';

import { SVGComponentProps } from './svg.types';

const FolderAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M8.94228 3.33333H13.3328C13.701 3.33333 13.9995 3.63181 13.9995 4V4.66667H1.99946V2.66667C1.99946 2.29848 2.29794 2 2.66613 2H7.60895L8.94228 3.33333ZM2.05733 6H13.9416C14.3098 6 14.6083 6.29848 14.6083 6.66667C14.6083 6.68513 14.6075 6.7036 14.606 6.722L14.0504 13.3887C14.0216 13.7342 13.7328 14 13.386 14H2.61288C2.26616 14 1.97732 13.7342 1.94852 13.3887L1.39296 6.722C1.36239 6.35511 1.63505 6.03288 2.00196 6.0023C2.02038 6.00077 2.03885 6 2.05733 6Z"
        fill={fill}
      />
    </svg>
  );
};

export default FolderAltSVG;
